<template>
  <v-container id="loginPage">
    <div id="login" @keyup.enter="login">
      <h1>Welcome Back!</h1>
      <br />
      <p class="text-center red--text">
        {{ errorMsg }}
      </p>
      <v-text-field
        v-model="input.username"
        type="text"
        class="rounded-0 darken-1"
        name="username"
        placeholder="Username"
      /><br />
      <v-text-field v-model="input.password" type="password" name="password" placeholder="Password" /><br />
      <v-btn type="button" large rounded color="accent" dark @click="login()"> Login </v-btn><br /><br />
      <router-link :to="'/create-account'" class="text-red"> Register Here </router-link>
    </div>
  </v-container>
</template>

<script>
import CookieTools from "../mixins/cookieTools";
import { mapMutations } from "vuex";

export default {
  name: "LoginPage",
  mixins: [CookieTools],

  metaInfo: {
    title: "Log In",
  },

  data() {
    return {
      input: {
        username: "",
        password: "",
      },
      errorMsg: "",
    };
  },

  methods: {
    ...mapMutations(["showSnackbar"]),

    login() {
      if (this.input.username === "") this.errorMsg = "username missing";
      else if (this.input.password === "") this.errorMsg = "password missing";
      else {
        let loginAuth = {
          password: this.input.password,
        };
        if (this.input.username.includes("@")) loginAuth.email = this.input.username;
        else loginAuth.username = this.input.username;

        this.$axios
          .post("/login", loginAuth)
          .then((response) => {
            let jsonToken = response.data;
            this.setCookie("authorization", jsonToken, 7);
            this.$store.commit("login", { authorization: jsonToken });
            this.$axios.defaults.headers.common["Authorization"] = `Bearer ${jsonToken}`;
            this.$router.push({ name: "home" });
          })
          .catch((err) => {
            if (err.response.status === 422) {
              this.errorMsg = "Username or Password is incorrect";
            } else {
              this.showSnackbar({
                text: "A server error occurred!",
                error: true,
              });
            }
          });
      }
    },
  },
};
</script>

<style scoped>
#loginPage {
  display: flex;
  align-items: center;
  height: 85vh;
}
#login {
  width: 500px;
  max-width: 90%;
  border: 1px solid #cccccc;
  background-color: #ffffff;
  margin: auto;
  padding: 20px;
  text-align: center;
}
</style>
